import { render } from "./PartnerAdd.vue?vue&type=template&id=2267bdd9&scoped=true"
import script from "./PartnerAdd.vue?vue&type=script&lang=js"
export * from "./PartnerAdd.vue?vue&type=script&lang=js"

import "./PartnerAdd.vue?vue&type=style&index=0&id=2267bdd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2267bdd9"]])

export default __exports__